import React, { FC } from "react";
import { Outlet } from "react-router-dom";

export const AuthLayout: FC<any> = () => {
  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-1">
        <Outlet />
      </div>
    </div>
  );
};
